export default __webpack_public_path__ + "static/media/TitilliumWeb-ExtraLightItalic.d8c6b1c6.ttf";